import { ComponentProcessor } from '../processor';
export class LiveComponentProcessor extends ComponentProcessor {
    process(provide, post) {
        const renderer = this.renderer();
        const hooks = [];
        provide({
            onBind: (fn) => hooks.push({ bind: fn }),
            onClear: (fn) => hooks.push({ clear: fn }),
        });
        post(node => {
            hooks.forEach(hook => renderer.hook(node, hook));
        });
    }
    priority() {
        return ComponentProcessor.PriorityFallback;
    }
}
//# sourceMappingURL=live-component.processor.js.map